"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Clock } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-primary-foreground/10 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="238156" id="footer" className="dark bg-background text-foreground pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="inline-block">
              
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs font-default">
              Albano Conta. Un progetto istituzionale per il futuro della nostra città, basato su trasparenza, competenza e presenza costante sul territorio.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 text-primary">Navigazione</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 text-primary">Contatti & Sedi</h3>
            <ul className="space-y-4 text-sm text-muted-foreground">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 shrink-0 text-secondary mt-0.5" />
                <span className="font-default">Via Cavour 41<br />00041 Albano Laziale (RM)</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 shrink-0 text-secondary" />
                <span className="font-default">+39 3452416177</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="size-5 shrink-0 text-secondary mt-0.5" />
                <span className="leading-relaxed font-default">
                  Segreteria Politica:<br />
                  Lunedì - Sabato: 09:00–20:00
                </span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-border mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground font-default">
          <p>© {new Date().getFullYear()} Borelli Sindaco. Albano Conta sempre.</p>
          <div className="flex items-center gap-6">
            <Link to="/InfrastructurePlanPage" className="text-foreground hover:text-secondary transition-colors font-semibold">
              Piano Infrastrutturale
            </Link>
            <Link to="#" className="text-foreground hover:text-secondary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="text-foreground hover:text-secondary transition-colors">
              Note Legali
            </Link>
          </div>
        </div>
      </div>
    </section>;
}